import React, { useEffect, useRef } from 'react'
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, LabelList } from 'recharts'

const PDFBarChart3 = ({ data = [], width = 700, height = 500, onLoaded }) => {
  const chartRef = useRef()
  const hasLoaded = useRef(false)

  const allZero = data.every(
    item =>
      item.openEmail === 0 &&
      item.linkedClicked === 0 &&
      item.attachmentOpened === 0 &&
      item.enterData === 0,
  )

  // Custom color palette for bars (for each tempId)
  // const colorPalette = ['#3498db', '#52b76a', '#e74c3c', '#ff9900', '#a4c619',]

  // 自定義顏色10種
  const colorPalette = [
    '#ff9900',
    '#a4c619',
    '#52b76a',
    '#b75275',
    '#A4D7CD',
    '#D6A4D7',
    '#3D85F0',
    '#318aa0ff',
    '#e74c3c',
    '#3186bfff',
  ]

  // 隨機打亂顏色
  // const shuffledColors = [...colorPalette].sort(() => 0.5 - Math.random())

  // Extract tempIds
  const tempIds = [...new Set(data.map(item => item.tempId))]

  // List of behaviors to display on the X-axis with Chinese names
  const behaviors = [
    { key: 'openEmail', label: '開啟信件' },
    { key: 'linkedClicked', label: '點擊連結' },
    { key: 'attachmentOpened', label: '開啟附件' },
    { key: 'enterData', label: '輸入資料' },
  ]

  // Transform data: Group by behavior and assign each tempId a value
  const transformedData = behaviors.map(({ key, label }) => {
    const behaviorData = { behavior: label } // Use the Chinese label for behavior
    tempIds.forEach(tempId => {
      const tempData = data.find(d => d.tempId === tempId)
      behaviorData[tempId] = tempData ? tempData[key] : 0 // Use raw number instead of percentage
    })
    return behaviorData
  })

  // Calculate the maximum number from the data
  const maxValue = Math.max(...transformedData.flatMap(item => tempIds.map(tempId => item[tempId])))

  // Increase Y-axis max by 20%
  const yAxisMax = maxValue + maxValue * 0.2

  // Generate ticks for the Y-axis with step of 10
  const yAxisTicks = Array.from({ length: Math.floor(yAxisMax / 10) + 1 }, (_, i) => i * 10)

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!hasLoaded.current) {
        hasLoaded.current = true
        onLoaded?.(chartRef.current)
      }
    }, 100)

    return () => {
      clearTimeout(timer)
    }
  }, [onLoaded])

  return (
    <div
      ref={chartRef}
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '20px',
        border: '4px solid rgb(182, 180, 180)',
        width: '100%',
        boxSizing: 'border-box',
        boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.3)',
        overflow: 'hidden',
      }}
    >
      <div style={{ position: 'absolute', top: 35, right: 20, fontSize: 17, fontWeight: 'bold' }}>
        單位: (人)
      </div>

      <BarChart
        width={width}
        height={height}
        data={transformedData}
        barCategoryGap={20}
        barGap={15}
        margin={{ top: 10, right: 30, left: 15, bottom: 30 }}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis
          dataKey="behavior"
          tick={({ x, y, payload }) => (
            <text x={x} y={y + 25} textAnchor="middle" fill="#666" fontSize={17} fontWeight="bold">
              {payload.value}
            </text>
          )}
        />
        <YAxis ticks={yAxisTicks} domain={[0, yAxisMax]} tickFormatter={value => `${value}`} />
        <Tooltip />
        {tempIds.map((tempId, index) => (
          <Bar
            key={tempId}
            dataKey={tempId}
            fill={colorPalette[index % colorPalette.length]}
            // fill={shuffledColors[index % shuffledColors.length]}
            name={`樣板: ${tempId}`}
            barSize={30}
          >
            <LabelList
              position="top"
              // formatter={value => `${value}`}
              formatter={value => (value > 0 ? `${value}` : '')}
              fill="#000000"
              fontSize={14}
              offset={10}
            />
          </Bar>
        ))}
        <Legend
          wrapperStyle={{
            position: 'absolute',
            top: '-40px',
            fontSize: '17px',
            left: '50px',
          }}
          itemMargin={{ horizontal: 40, vertical: 20 }}
        />
        {allZero && (
          <text
            x={width / 2}
            y={height / 3}
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize={20}
            fontFamily="Noto Sans"
            fill="#000"
            fontWeight="bold"
          >
            本次演練總釣中人數: 0人
          </text>
        )}
      </BarChart>
    </div>
  )
}

export default PDFBarChart3
